// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"SuperZoomImage_imageWrapper__h4WIL","show":"SuperZoomImage_show__E7mUJ","image":"SuperZoomImage_image__k5Cit","closeButton":"SuperZoomImage_closeButton__wlprU"};